import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import UICheckbox from 'UIComponents/input/UICheckbox';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { removeFromCompareProducts, addToCompareProducts } from '../../actions/CompareActions';
import { getCompareApiNamesSelector, isApiNameInCompareSelector, isCompareAtLimitSelector } from '../../selectors/CompareSelectors';
import { ApiNameToProductTranslationKeyMap } from '../../constants/ApiNameToProductTranslationKeyMap';

const CompareCheckbox = ({
  apiName
}) => {
  const dispatch = useDispatch();
  const compareApiNames = useSelector(getCompareApiNamesSelector, shallowEqual);
  const isChecked = useSelector(state => {
    return isApiNameInCompareSelector(state, {
      apiName
    });
  });
  const isCompareAtLimit = useSelector(isCompareAtLimitSelector);

  const handleChange = () => {
    if (isChecked) {
      dispatch(removeFromCompareProducts(apiName));
      getUsageTracker().track('compareToolInteraction', {
        action: 'removed product',
        product: apiName,
        productNames: compareApiNames
      });
    } else {
      dispatch(addToCompareProducts(apiName));
      getUsageTracker().track('compareToolInteraction', {
        action: 'added product',
        product: apiName,
        productNames: compareApiNames
      });
    }
  };

  return /*#__PURE__*/_jsxs(UICheckbox, {
    checked: isChecked,
    value: apiName,
    onChange: handleChange,
    disabled: !isChecked && isCompareAtLimit,
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "compare.compareButton"
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      className: "sr-only",
      message: ApiNameToProductTranslationKeyMap[apiName]
    })]
  });
};

export default CompareCheckbox;